{
  "form": {
    "title": "Specialty",
    "name": "Name",
    "description": "Description",
    "create": "Create Speciality",
    "update": "Update Speciality",
    "exclusive_true": "Yes",
    "exclusive_false": "No",
    "exclusive": "Will you teach students with this attribute exclusively?",
    "attributes_title": "Attributes",
    "attributes_info": "Select one or more attribute to define for this specialty.",
    "attributes_select": "Please select one or more attributes to add",
    "from": "From",
    "to": "To",
    "religion_title": "Religion",
    "religion_select": "Select all religions",
    "measurement_unit": "Measurement Unit",
    "religion_note": "Describe your specialisation with these students of these religion's.",
    "gender_title": "Gender",
    "gender_notes": "Describe your specialisation with these students of these gender's.",
    "primary_language_title": "Primary Language",
    "primary_language_select": "Select all primary languages",
    "primary_language_note": "Describe your specialisation with these students of these languages.",
    "secondary_language_title": "Secondary Language",
    "secondary_language_select": "Select all secondary languages",
    "secondary_language_note": "Describe your specialisation with these students of these languages.",
    "eyesight_title": "Eyesight",
    "adhd_title": "ADHD",
    "autism_title": "Autism",
    "depression_title": "Depression",
    "socio_economic_title": "Socio Economic",
    "socio_economic_aboriginal_torres_strait_islander": "Specialise in teaching Aboriginal/Torres Strait Islander students?",
    "socio_economic_aboriginal_torres_strait_islander_true": "Yes",
    "socio_economic_aboriginal_torres_strait_islander_false": "No",
    "socio_economic_icsea_percentile": "School ICSEA Percentile",
    "socio_economic_icsea_percentile_from": "From (%)",
    "socio_economic_icsea_percentile_to": "To (%)",
    "socio_economic_comment": "Comments",
    "socio_economic_other_comment": "General Comments",
    "parent_socioeconomic-section-title": "Parent Socioeconomic",
    "parent_education_from": "Education From",
    "parent_education_to": "Education To",
    "parent_education_requires_both": "Education requirement applies to:",
    "parent_occupation_from": "Occupation From",
    "parent_occupation_to": "Occupation To",
    "parent_occupation_requires_both": "Occupation requirement applies to:",
    "parent_true": "Both Parents",
    "parent_false": "At Least One Parent",

    "qualitative_title": "Overall Qualitative Assessment",
    "qualitative_from": "Score From (Inclusive)",
    "qualitative_to": "Score To (Inclusive)",
    "grade_title": "Subject Grade Range",
    "grade_from": "Grade From (Inclusive)",
    "grade_to": "Grade To (Inclusive)",
    "naplan_title": "NAPLAN Score (Year 9)",
    "naplan_numeracy_from": "Numeracy From",
    "naplan_numeracy_to": "Numeracy To",
    "naplan_reading_from": "Reading From",
    "naplan_reading_to": "Reading To",
    "naplan_writing_from": "Writing From",
    "naplan_writing_to": "Writing To",
    "naplan_spelling_from": "Spelling From",
    "naplan_spelling_to": "Spelling To",
    "naplan_grammar_from": "Grammar From",
    "naplan_grammar_to": "Grammar To",
    "wisc_title": "WISC V",
    "wisc_year": "WISC-V Year",
    "eyesight_from": "From Impairment Level",
    "eyesight_to": "To Impairment Level",
    "wisc_v_attributes": {
      "wisc_v_vci_from": "Verbal Comprehension Index(VCI) Percentile From",
      "wisc_v_vci_to": "Verbal Comprehension Index(VCI) Percentile To",
      "wisc_v_wmi_from": "Working Memory Index(WMI) Percentile From",
      "wisc_v_wmi_to": "Working Memory Index(WMI) Percentile To",
      "wisc_v_psi_from": "Processing Speed Index(PSI) Percentile From",
      "wisc_v_psi_to": "Processing Speed Index(PSI) Percentile To",
      "wisc_v_fsiq_from": "Full Scale IQ Percentile From",
      "wisc_v_fsiq_to": "Full Scale IQ Percentile To",
      "wisc_v_fri_from": "Fluid Reasoning Index(FRI) Percentile From",
      "wisc_v_fri_to": "Fluid Reasoning Index(FRI) Percentile To",
      "wisc_v_vsi_from": "Visual Spatial Index(VSI) Percentile From",
      "wisc_v_vsi_to": "Visual Spatial Index(VSI) Percentile To"
    },
    "not_at_all": "Not at all",
    "mildly": "Mildly",
    "average": "Average",
    "high_extended": "To a high extent",
    "very_high_extend": "To a very high extent",

    "vark_title": "Vark",
    "learning_style_visual_to": "Visual To",
    "learning_style_auditory_to": "Auditory To",
    "learning_style_kinesthetic_to": "Kinesthetic To",
    "learning_style_read_write_to": "Reading/Writing To",
    "learning_style_visual_from": "Visual From",
    "learning_style_auditory_from": "Auditory From",
    "learning_style_kinesthetic_from": "Kinesthetic From",
    "learning_style_read_write_from": "Reading/Writing From",

    "learning_style_description": "Learning Style Description",

    "learning_style_linguistic_from": "Linguistic From",
    "learning_style_linguistic_to": "Linguistic To",
    "learning_style_logical_from": "Logical-Mathematical From",
    "learning_style_logical_to": "Logical-Mathematical To",
    "learning_style_musical_from": "Musical From",
    "learning_style_musical_to": "Musical To",
    "learning_style_spatial_from": "Spatial From",
    "learning_style_spatial_to": "Spatial To",
    "learning_style_body_kinesthetic_from": "Bodily-Kinesthetic From",
    "learning_style_body_kinesthetic_to": "Bodily-Kinesthetic To",
    "learning_style_interpersonal_from": "Interpersonal From",
    "learning_style_interpersonal_to": "Interpersonal To",
    "learning_style_intrapersonal_from": "Intrapersonal From",
    "learning_style_intrapersonal_to": "Intrapersonal To",
    "learning_style_naturalistic_from": "Naturalistic From",
    "learning_style_naturalistic_to": "Naturalistic To",

    "gardner_title": "Gardner's Multiple Intelligences",
    "learning_style_concrete_exp_from": "Concrete Experience (CE) From",
    "learning_style_concrete_exp_to": "Concrete Experience (CE) To",
    "learning_style_reflective_obs_from": "Reflective Observation (RO) From",
    "learning_style_reflective_obs_to": "Reflective Observation (RO) To",
    "learning_style_abstract_conc_from": "Abstract Conceptualization (AC) From",
    "learning_style_abstract_conc_to": "Abstract Conceptualization (AC) To",
    "learning_style_active_exp_from": "Active Experimentation (AE) From",
    "learning_style_active_exp_to": "Active Experimentation (AE) To",
    "kolbs_title": "Kolb’s Experiential Learning Theory",
    "general_description": "General Description",
    "learning_preference_attributes": {
      "learning_preference_group": "Learning in Groups (Collaborative Learning)",
      "learning_preference_individual": "Learning Individually (Independent Learning)",
      "learning_preference_like_students": "Learning with Like Students (Homogeneous Grouping)",
      "learning_preference_diverse_students": "Learning with Diverse Students (Heterogeneous Grouping)",
      "learning_preference_teacher_centered": "Teacher-Centered vs. Student-Centered Learning:",
      "learning_preference_teacher_centered_lower": "Teacher-Centered",
      "learning_preference_teacher_centered_upper": "Student-Centered",
      "learning_preference_structured": "Structured vs. Flexible Learning:",
      "learning_preference_structured_lower": "Structured",
      "learning_preference_structured_upper": "Flexible Learning",
      "learning_preference_technology_enhanced": "Technology-Enhanced Learning:",
      "learning_preference_technology_enhanced_lower": "Traditional",
      "learning_preference_technology_enhanced_upper": "Technology",
      "learning_preference_by_doing": "Learning by Doing vs. Learning by Observing:",
      "learning_preference_by_doing_lower": "Doing",
      "learning_preference_by_doing_upper": "Observing"
    },
    "wiat_title": "WIAT IV",
    "wiat_age": "WIAT IV Age",
    "wiat_iv_attributes": {
      "wiat_iv_total_achievement_composite_from": "Percentile Total Achievement Composite Percentile From",
      "wiat_iv_word_reading_from": "Word Reading Percentile From",
      "wiat_iv_reading_comprehension_from": "Reading Comprehension Percentile From",
      "wiat_iv_spelling_from": "Spelling Percentile From",
      "wiat_iv_sentence_composition_from": "Sentence Composition Percentile From",
      "wiat_iv_math_problem_solving_from": "Math Problem Solving Percentile From",
      "wiat_iv_numerical_operations_from": "Numerical Operations Percentile From",
      "wiat_iv_reading_composite_from": "Reading Composite Percentile From",
      "wiat_iv_written_expression_composite_from": "Written Expression Composite Percentile From",
      "wiat_iv_mathematics_composite_from": "Mathematics Composite Percentile From",
      "wiat_iv_basic_reading_composite_from": "Basic Reading Composite Percentile From",
      "wiat_iv_decoding_composite_from": "Decoding Composite Percentile From",
      "wiat_iv_reading_fluency_composite_from": "Reading Fluency Composite Percentile From",
      "wiat_iv_math_fluency_composite_from": "Math Fluency Composite Percentile From",
      "wiat_iv_writing_fluency_composite_from": "Writing Fluency Composite Percentile From",
      "wiat_iv_oral_language_composite_from": "Oral Language Composite Percentile From",
      "wiat_iv_phonological_proc_composite_from": "Phonological Processing Composite Percentile From",
      "wiat_iv_ortho_proc_composite_from": "Orthographic Processing Composite Percentile From",
      "wiat_iv_ortho_proc_extended_composite_from": "Orthographic Processing Extended Composite Percentile From",
      "wiat_iv_dyslexia_index_composite_from": "Dyslexia Index Composite Percentile From",
      "wiat_iv_total_achievement_composite_to": "Percentile Total Achievement Composite Percentile To",
      "wiat_iv_word_reading_to": "Word Reading Percentile To",
      "wiat_iv_reading_comprehension_to": "Reading Comprehension Percentile To",
      "wiat_iv_spelling_to": "Spelling Percentile To",
      "wiat_iv_sentence_composition_to": "Sentence Composition Percentile To",
      "wiat_iv_math_problem_solving_to": "Math Problem Solving Percentile To",
      "wiat_iv_numerical_operations_to": "Numerical Operations Percentile To",
      "wiat_iv_reading_composite_to": "Reading Composite Percentile To",
      "wiat_iv_written_expression_composite_to": "Written Expression Composite Percentile To",
      "wiat_iv_mathematics_composite_to": "Mathematics Composite Percentile To",
      "wiat_iv_basic_reading_composite_to": "Basic Reading Composite Percentile To",
      "wiat_iv_decoding_composite_to": "Decoding Composite Percentile To",
      "wiat_iv_reading_fluency_composite_to": "Reading Fluency Composite Percentile To",
      "wiat_iv_math_fluency_composite_to": "Math Fluency Composite Percentile To",
      "wiat_iv_writing_fluency_composite_to": "Writing Fluency Composite Percentile To",
      "wiat_iv_oral_language_composite_to": "Oral Language Composite Percentile To",
      "wiat_iv_phonological_proc_composite_to": "Phonological Processing Composite Percentile To",
      "wiat_iv_ortho_proc_composite_to": "Orthographic Processing Composite Percentile To",
      "wiat_iv_ortho_proc_extended_composite_to": "Orthographic Processing Extended Composite Percentile To",
      "wiat_iv_dyslexia_index_composite_to": "Dyslexia Index Composite Percentile To"
    },
    "aeas_title": "AEAS",
    "aeas_attributes": {
      "aeas_score_reading_from": "Reading Comprehension From",
      "aeas_score_spelling_from": "Vocabulary/Spelling From",
      "aeas_score_written_essay_from": "Written Essay From",
      "aeas_score_listening_from": "Listening From",
      "aeas_score_speaking_from": "Speaking From",
      "aeas_score_overall_from": "Overall From",
      "aeas_score_reading_to": "Reading Comprehension To",
      "aeas_score_spelling_to": "Vocabulary/Spelling To",
      "aeas_score_written_essay_to": "Written Essay To",
      "aeas_score_listening_to": "Listening To",
      "aeas_score_speaking_to": "Speaking To",
      "aeas_score_overall_to": "Overall To"
    },
    "wais_title": "WAIS IV",
    "wais_iv_attributes": {
      "wais_iv_full_scale_iq_from": "Full Scale IQ Percentile From",
      "wais_iv_general_ability_from": "General Ability Index Percentile From",
      "wais_iv_verbal_comprehension_from": "Verbal Comprehension Index(VCI) Percentile From",
      "wais_iv_perceptual_reasoning_from": "Perceptual Reasoning Index(PRI) Percentile From",
      "wais_iv_working_memory_from": "Working Memory Index(WMI) Percentile From",
      "wais_iv_proc_speed_from": "Processing Speed Index(PSI) Percentile From",
      "wais_iv_full_scale_iq_to": "Full Scale IQ Percentile To",
      "wais_iv_general_ability_to": "General Ability Index Percentile To",
      "wais_iv_verbal_comprehension_to": "Verbal Comprehension Index(VCI) Percentile To",
      "wais_iv_perceptual_reasoning_to": "Perceptual Reasoning Index(PRI) Percentile To",
      "wais_iv_working_memory_to": "Working Memory Index(WMI) Percentile To",
      "wais_iv_proc_speed_to": "Processing Speed Index(PSI) Percentile To"
    },
    "adhd_attributes": {
      "f90_0_predominantly_inattentive_type": "F90.0 Attention-deficit hyperactivity disorder, predominantly inattentive type",
      "f90_1_predominantly_hyperactive_type": "F90.1 Attention-deficit hyperactivity disorder, predominantly hyperactive type",
      "f90_2_combined_type": "F90.2 Attention-deficit hyperactivity disorder, combined type",
      "f90_8_other_type": "F90.8 Attention-deficit hyperactivity disorder, other type",
      "f90_9_unspecified_type": "F90.9 Attention-deficit hyperactivity disorder, unspecified type"
    },
    "autism_attributes": {
      "f84_0_childhood_autism": "F84.0 Childhood autism",
      "f84_1_atypical_autism": "F84.1 Atypical autism",
      "f84_2_rett_syndrome": "F84.2 Rett syndrome",
      "f84_3_other_childhood_disintegrative_disorder": "F84.3 Other childhood disintegrative disorder",
      "f84_4_overactive_disorder_associated_with_mental_retardation_and_stereotyped_movements": "F84.4 Overactive disorder associated with mental retardation and stereotyped movements",
      "f84_5_asperger_syndrome": "F84.5 Asperger syndrome",
      "f84_8_other_pervasive_developmental_disorders": "F84.8 Other pervasive developmental disorders",
      "f84_9_unspecified_pervasive_developmental_disorder": "F84.9 Unspecified pervasive developmental disorder"
    },
    "depression_attributes": {
      "f33_0_recurrent_depressive_disorder_current_episode_mild": "F33.0 Recurrent depressive disorder, current episode mild",
      "f33_1_recurrent_depressive_disorder_current_episode_moderate": "F33.1 Recurrent depressive disorder, current episode moderate",
      "f33_2_recurrent_depressive_disorder_current_episode_severe_without_psychotic_symptoms": "F33.2 Recurrent depressive disorder, current episode severe without psychotic symptoms",
      "f33_3_recurrent_depressive_disorder_current_episode_severe_with_psychotic_symptoms": "F33.3 Recurrent depressive disorder, current episode severe with psychotic symptoms",
      "f33_4_recurrent_depressive_disorder_currently_in_remission": "F33.4 Recurrent depressive disorder, currently in remission",
      "f33_8_other_recurrent_depressive_disorders": "F33.8 Other recurrent depressive disorders",
      "f33_9_recurrent_depressive_disorder_unspecified": "F33.9 Recurrent depressive disorder, unspecified"
    }
  },
  "index": {
    "title": "Specialities",
    "create": "Create Speciality",
    "empty_list_title": "No Specialities",
    "empty_list_description": "Click the create button to create your first speciality."
  },
  "new": {
    "title": "Create Speciality",
    "speciality_scope": {
      "label": "Speciality Scope",
      "personal_label": "Personal Profile",
      "personal_description": "This speciality will appear on your personal profile and represent your individual expertise.",
      "team_label": "Team Profile",
      "team_description": "This speciality will be shared on your team’s profile so others can see what your team offers."
    },
    "team_select": {
      "label": "Team",
      "placeholder": "Select team"
    }
  },
  "edit": {
    "title": "Edit Speciality"
  },
  "wizard": {
    "eligibility_mode": "Eligibility mode",
    "selective": "Selective",
    "descriptive": "Descriptive",
    "continue": "Continue",
    "categories": "Choose catalogue content",
    "configure": "Configure",
    "edit": "Edit",
    "deselect": "Deselect",
    "selected": "Selected",
    "review": "Review",
    "back_to_categories": "Back to categories",
    "selective_criterion_required": "Select at least one active evaluable criterion before saving a selective speciality.",
    "catalogue_content_unavailable": "Unavailable catalogue content"
  },
  "attributes": {
    "religion.label": "Religions Taught",
    "religion.group": "Religion",
    "gender.label": "Genders Taught",
    "gender.group": "Gender",
    "languages.primary.label": "Primary Languages",
    "languages.secondary.label": "Secondary Languages",
    "languages.group": "Languages",
    "intellectual_ability.group": "Intellectual Ability",
    "intellectual_ability.qualitative.label": "Overall Qualitative Assessment",
    "intellectual_ability.subject_grade.label": "Subject Grade Range",
    "intellectual_ability.naplan.label": "NAPLAN Score (Year 9)",
    "intellectual_ability.wisc_v.label": "WISC V",
    "intellectual_ability.wiat_iv.label": "WIAT IV",
    "intellectual_ability.wais_iv.label": "WAIS IV",
    "intellectual_ability.aeas.label": "AEAS",
    "parent_socio_economic.group": "Parent Socioeconomic",
    "parent_socio_economic.label": "Parent Socioeconomic Details",
    "learning_styles.group": "Learning Styles",
    "learning_styles.description.label": "Description",
    "learning_styles.vark.label": "VARK",
    "learning_styles.gardner.label": "Gardner's Multiple Intelligences",
    "learning_styles.kolb.label": "Kolb's Experiential Learning Theory",
    "learning_preferences.group": "Learning Preferences",
    "learning_preferences.label": "Students Learning Preferences",
    "other_information.group": "Other Information",
    "other_information.eyesight.label": "Eyesight",
    "other_information.adhd.label": "ADHD",
    "other_information.autism.label": "Autism",
    "other_information.depression.label": "Depression",
    "student_socio_economic.group": "Socio Economic",
    "student_socio_economic.label": "Student Socio Economic details"
  }
}
